import { useState } from "react";
import Tabs from "../../components/Tabs";
import MyProfile from "./tabComponents/myProfile";
import MyAuctions from "./tabComponents/myAuctions";
import CreateNewAuction from "./tabComponents/createNewAuctions";
const Account = () => {
  const [tabs] = useState(["My Profile", "My Auctions", "Create New Auction"]);
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const RenderComponent = (tab: number) => {
    switch (tab) {
      case 0:
        return <MyProfile />;
      case 1:
        return <MyAuctions />;
      case 2:
        return <CreateNewAuction />;
      default:
        <MyProfile />;
    }
  };
  return (
    <div className="flex justify-center items-center mt-5 flex-col">
      <h1>Auctioner Account Page</h1>
      <Tabs
        tabs={tabs}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <div className="mt-5">{RenderComponent(selectedTab)}</div>
    </div>
  );
};

export default Account;
